// extracted by mini-css-extract-plugin
var _1 = "ecGI9";
var _2 = "Xub2b";
var _3 = "Dk17S";
var _4 = "igUBI";
var _5 = "KA9c0";
var _6 = "kP2uB";
var _7 = "fVXy2";
var _8 = "frnPJ";
export { _1 as "gap-1", _2 as "gap-2", _3 as "gap-3", _4 as "gap-4", _5 as "gap-5", _6 as "gap-6", _7 as "gap-7", _8 as "gap-8" }
